const stickySection = document.querySelector('.article-column.sticky-section');
const stickyHeader = document.getElementById('shopify-section-header');
let isObserving = false;
const observer = new MutationObserver((m) => {
  m.forEach(mut => {
    if(mut.attributeName == "class"){
      if(!stickyHeader.classList.contains('shopify-section-header-hidden')){
        const headerHeight = stickyHeader.offsetHeight;
        if(stickySection && stickySection.style) {
          stickySection.style.top = `${headerHeight + 40}px`;
        }
      }
      else {
        if(stickySection && stickySection.style) {
          stickySection.style.top = "";
        }
      }
    }
  })
})
if(window.innerWidth >= 750){
  isObserving = true;
  observer.observe(stickyHeader, {attributes:true});
}

window.addEventListener('resize', () => {
  if(!isObserving && window.innerWidth >= 750){
    observer.observe(stickyHeader, {attributes:true});
    isObserving = true;
  }
  else if(isObserving && window.innerWidth < 750){
    observer.disconnect();
    isObserving = false;
  }
})

